(function () {
  'use strict';

  var STORAGE_KEY_PREFIX = 'bb-wishlist-variants';
  var GUEST_STORAGE_KEY = STORAGE_KEY_PREFIX + '-guest';
  var SYNC_DEBOUNCE_MS = 800;
  var HEART_ICON_SVG = '<svg class="icon-heart-outline" viewBox="0 0 752 701" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M522.38 0.332822C582.003 -2.97253 640.331 18.4561 683.621 59.5262L684.641 60.4998L685.047 60.8983C685.18 61.033 685.313 61.1696 685.443 61.3074C773.009 153.846 773.009 298.683 685.443 391.221C685.385 391.283 685.326 391.345 685.266 391.406L539.593 542.102C539.581 542.114 539.569 542.126 539.557 542.138L392.83 693.287C388.316 697.937 382.113 700.564 375.632 700.57C369.151 700.576 362.943 697.961 358.42 693.319L211.592 542.623C211.57 542.6 211.547 542.577 211.525 542.555L65.8523 391.858C65.7932 391.797 65.7341 391.735 65.6756 391.674C-21.8919 299.135 -21.8918 154.298 65.6756 61.7596L66.0711 61.3504C66.2048 61.2156 66.3405 61.0825 66.4773 60.951C109.87 19.247 168.644 -2.54634 228.736 0.78497C284.79 3.89237 337.285 28.5989 375.348 69.4373C413.445 28.329 466.121 3.45179 522.38 0.332822ZM650.965 94.7127C617.22 62.4988 571.638 45.6752 525.037 48.2586C478.246 50.8526 434.64 72.7771 404.65 108.785C404.268 109.244 403.868 109.688 403.453 110.117L392.854 121.067C388.408 125.661 382.312 128.291 375.919 128.374C369.526 128.456 363.364 125.984 358.801 121.507L348.101 111.008C347.528 110.445 346.983 109.854 346.469 109.237C316.479 73.2294 272.872 51.3048 226.08 48.7108C179.476 46.1271 133.891 62.9532 100.143 95.1736C30.5043 169.204 30.6192 284.736 100.49 358.629L246.037 509.193H246.036L375.577 642.146L505.117 508.705L650.627 358.177C720.5 284.281 720.612 168.743 650.965 94.7127Z" fill="currentColor"/></svg>';
  var CART_ICON_SVG = '<svg class="icon-cart" width="16" height="16" viewBox="0 0 29 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M25.9075 5.64276H24.8462L19.5756 0.314853V0.313456C19.1583 -0.105646 18.4853 -0.104251 18.0693 0.31625C17.6547 0.736746 17.6547 1.41845 18.0721 1.83755L21.8433 5.64305H7.50729L11.2785 1.83755C11.6683 1.41427 11.6572 0.756308 11.2537 0.34697C10.8488 -0.060938 10.1979 -0.0721315 9.77913 0.321825L4.50858 5.64973H3.09348C1.55261 5.65113 0.248059 6.79664 0.031124 8.3375C-0.185839 9.87977 0.751128 11.3466 2.22977 11.7824L3.76926 21.2456C4.13687 23.4877 6.05497 25.1319 8.30325 25.1333H20.6854C22.9407 25.1375 24.8656 23.4877 25.2321 21.2384L26.7716 11.7753C28.2489 11.3394 29.1858 9.87122 28.9689 8.33035C28.7519 6.78949 27.4474 5.64397 25.9079 5.64258L25.9075 5.64276ZM23.1381 20.888C22.9419 22.0992 21.9068 22.9876 20.6935 22.9876H8.31131C7.09797 22.9876 6.06289 22.1006 5.86665 20.8922L4.39767 11.9011H24.599L23.1381 20.888ZM25.9075 9.75546H3.08898C2.55142 9.75546 2.1161 9.3154 2.1161 8.77199C2.1161 8.22857 2.55142 7.78851 3.08898 7.78851H25.9075C26.4451 7.78851 26.8804 8.22857 26.8804 8.77199C26.8804 9.3154 26.4451 9.75546 25.9075 9.75546Z" fill="currentColor"/></svg>';
  var BIN_ICON_SVG = '<svg class="icon-bin" width="13" height="17" viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M11.3752 5.95009C11.7919 5.95009 12.1354 6.2784 12.1819 6.70073L12.188 6.80033V16.1498C12.188 16.5856 11.8741 16.945 11.4697 16.9936L11.3752 17H1.62483C1.20816 17 0.864615 16.6717 0.818145 16.2486L0.812051 16.1498V6.80033C0.812051 6.33098 1.17617 5.95008 1.62484 5.95008C2.04151 5.95008 2.38506 6.27839 2.43153 6.70072L2.43762 6.80032V15.2995H10.5624V6.80032C10.5624 6.36445 10.8762 6.00507 11.2807 5.95567L11.3752 5.95009ZM4.87522 5.95009C5.29189 5.95009 5.63543 6.2784 5.6819 6.70073L5.68724 6.80033V12.7496C5.68724 13.2189 5.32388 13.5998 4.87521 13.5998C4.45854 13.5998 4.11499 13.2715 4.06776 12.8492L4.06243 12.7496V6.80034C4.06243 6.33099 4.42655 5.95009 4.87522 5.95009ZM8.12482 5.95009C8.54149 5.95009 8.88504 6.2784 8.93227 6.70073L8.9376 6.80033V12.7496C8.9376 13.2189 8.57348 13.5998 8.12481 13.5998C7.70814 13.5998 7.36459 13.2715 7.31812 12.8492L7.31279 12.7496V6.80034C7.31279 6.33099 7.67615 5.95009 8.12482 5.95009ZM8.93761 6.03085e-06C9.25526 6.03085e-06 9.54092 0.193641 9.67345 0.49006L9.70849 0.581698L10.3354 2.54991H12.188C12.6366 2.54991 13 2.93081 13 3.40015C13 3.83603 12.6869 4.1954 12.2824 4.24401L12.188 4.25039H0.812029C0.363357 4.25039 0 3.86949 0 3.40014C0 2.96427 0.313084 2.6049 0.717568 2.55628L0.812026 2.54991H2.66383L3.29152 0.581698C3.39207 0.26614 3.65792 0.043828 3.96796 0.0063748L4.06242 0L8.93761 6.03085e-06ZM8.35183 1.70048H4.64747L4.37629 2.54993H8.62219L8.35183 1.70048Z" fill="currentColor"/></svg>';
  var cartVariantIdsCache = {};
  var cartFetchPromise = null;
  var memoryStore = {};
	  var syncTimer = null;
	  var isSyncInFlight = false;

	  function getRootPath() {
	    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
	    if (typeof root !== 'string' || !root) {
	      root = '/';
	    }
	    return root.charAt(root.length - 1) === '/' ? root : root + '/';
	  }

	  var ROOT_PATH = getRootPath();

  function getWishlistLabels() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    var isDutch = lang.indexOf('nl') === 0;
    var isGerman = lang.indexOf('de') === 0;
    var isFrench = lang.indexOf('fr') === 0;

    if (isGerman) {
      return {
        cart: 'Warenkorb',
        adding: 'Wird hinzugefügt...',
        added: 'Hinzugefügt',
        retry: 'Erneut',
        addedToCart: 'Hinzugefügt',
        onWishlist: 'Auf der Wunschliste',
        wishlist: 'Wunschliste',
        save: 'Speichern',
        removeFromWishlist: 'Von der Wunschliste entfernen'
      };
    }

    if (isDutch) {
      return {
        cart: 'Winkelmand',
        adding: 'Toevoegen...',
        added: 'Toegevoegd',
        retry: 'Opnieuw',
        addedToCart: 'Toegevoegd',
        onWishlist: 'Op verlanglijst',
        wishlist: 'Verlanglijst',
        save: 'Opslaan',
        removeFromWishlist: 'Verwijderen van verlanglijst'
      };
    }

    if (isFrench) {
      return {
        cart: 'Panier',
        adding: 'Ajout en cours...',
        added: 'Ajouté',
        retry: 'Réessayer',
        addedToCart: 'Ajouté',
        onWishlist: 'Dans la liste de souhaits',
        wishlist: 'Liste de souhaits',
        save: 'Enregistrer',
        removeFromWishlist: 'Retirer de la liste de souhaits'
      };
    }

    // Standaard (en + onbekende talen): Engels.
    return {
      cart: 'Cart',
      adding: 'Adding...',
      added: 'Added',
      retry: 'Retry',
      addedToCart: 'Added',
      onWishlist: 'On wishlist',
      wishlist: 'Wishlist',
      save: 'Save',
      removeFromWishlist: 'Remove from wishlist'
    };
  }

  var labels = getWishlistLabels();

  function parseList(rawValue) {
    if (!rawValue && rawValue !== 0) {
      return [];
    }

    if (Array.isArray(rawValue)) {
      return rawValue;
    }

    if (typeof rawValue !== 'string') {
      return [];
    }

    try {
      var parsed = JSON.parse(rawValue);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function toVariantId(value) {
    if (value === null || value === undefined) {
      return '';
    }

    var normalized = String(value).trim();
    return /^\d+$/.test(normalized) ? normalized : '';
  }

  function normalizeWishlistItem(input) {
    if (!input && input !== 0) {
      return null;
    }

    if (typeof input === 'number') {
      var numericId = toVariantId(input);
      return numericId ? { variantId: numericId, handle: '' } : null;
    }

    if (typeof input === 'string') {
      var trimmed = input.trim();
      if (!trimmed) {
        return null;
      }

      if (trimmed.indexOf('::') !== -1) {
        var split = trimmed.split('::');
        var splitVariantId = toVariantId(split[0]);
        if (!splitVariantId) {
          return null;
        }
        return {
          variantId: splitVariantId,
          handle: String(split[1] || '').trim()
        };
      }

      var stringVariantId = toVariantId(trimmed);
      if (stringVariantId) {
        return { variantId: stringVariantId, handle: '' };
      }

      return null;
    }

    if (typeof input === 'object') {
      var objectVariantId = toVariantId(input.variantId || input.variant_id || input.id);
      if (!objectVariantId) {
        return null;
      }

      return {
        variantId: objectVariantId,
        handle: typeof input.handle === 'string' ? input.handle.trim() : ''
      };
    }

    return null;
  }

  function uniqItems(items) {
    var seen = {};
    var output = [];

    (items || []).forEach(function (item) {
      var normalized = normalizeWishlistItem(item);
      if (!normalized || seen[normalized.variantId]) {
        return;
      }

      seen[normalized.variantId] = true;
      output.push(normalized);
    });

    return output;
  }

  function toVariantMap(items) {
    var map = {};
    uniqItems(items).forEach(function (item) {
      map[item.variantId] = true;
    });
    return map;
  }

  function areWishlistListsEqual(a, b) {
    var mapA = toVariantMap(a);
    var mapB = toVariantMap(b);
    var keysA = Object.keys(mapA);
    var keysB = Object.keys(mapB);

    if (keysA.length !== keysB.length) {
      return false;
    }

    return keysA.every(function (key) {
      return !!mapB[key];
    });
  }

  function serializeItems(items) {
    return items.map(function (item) {
      return item.variantId + '::' + (item.handle || '');
    });
  }

  function deserializeItems(rawList) {
    return uniqItems(parseList(rawList));
  }

  function storageGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return typeof memoryStore[key] === 'string' ? memoryStore[key] : '[]';
    }
  }

  function storageSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      memoryStore[key] = value;
    }
  }

  function storageRemove(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      delete memoryStore[key];
    }
  }

  function getWishlistConfig() {
    var defaultConfig = {
      isLoggedIn: false,
      customerId: null,
      customerWishlistMetafield: [],
      syncUrl: '',
      syncEnabled: false
    };

    var node = document.getElementById('bb-wishlist-config');
    if (!node) {
      return defaultConfig;
    }

    try {
      var parsed = JSON.parse(node.textContent || '{}');
      return {
        isLoggedIn: !!parsed.isLoggedIn,
        customerId: parsed.customerId || null,
        customerWishlistMetafield: parsed.customerWishlistMetafield,
        syncUrl: typeof parsed.syncUrl === 'string' ? parsed.syncUrl : '',
        syncEnabled: !!parsed.syncEnabled
      };
    } catch (error) {
      return defaultConfig;
    }
  }

  var config = getWishlistConfig();

  function getCustomerStorageKey() {
    if (!config.customerId) {
      return '';
    }

    return STORAGE_KEY_PREFIX + '-customer-' + String(config.customerId);
  }

  function getActiveStorageKey() {
    return config.isLoggedIn && config.customerId ? getCustomerStorageKey() : GUEST_STORAGE_KEY;
  }

  function readItemsFromKey(key) {
    return deserializeItems(storageGet(key));
  }

  function getWishlistItems() {
    return readItemsFromKey(getActiveStorageKey());
  }

  function getWishlistVariantIds() {
    return getWishlistItems().map(function (item) {
      return item.variantId;
    });
  }

  function saveWishlistItems(items, options) {
    var nextItems = uniqItems(items);
    storageSet(getActiveStorageKey(), JSON.stringify(serializeItems(nextItems)));

    if (!options || !options.skipRemoteSync) {
      queueRemoteSync(nextItems);
    }
  }

  function hasVariant(variantId) {
    var normalizedVariantId = toVariantId(variantId);
    if (!normalizedVariantId) {
      return false;
    }

    return getWishlistVariantIds().indexOf(normalizedVariantId) !== -1;
  }

  function upsertWishlistItem(itemInput) {
    var nextItem = normalizeWishlistItem(itemInput);
    if (!nextItem) {
      return false;
    }

    var list = getWishlistItems();
    var index = -1;

    list.forEach(function (entry, i) {
      if (entry.variantId === nextItem.variantId) {
        index = i;
      }
    });

    if (index === -1) {
      list.push(nextItem);
      saveWishlistItems(list);
      return true;
    }

    list.splice(index, 1);
    saveWishlistItems(list);
    return false;
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var lang = (document.documentElement.lang || '').toLowerCase();
    var locale = 'en';
    if (lang.indexOf('nl') === 0) locale = 'nl-NL';
    else if (lang.indexOf('de') === 0) locale = 'de-DE';
    else if (lang.indexOf('fr') === 0) locale = 'fr-FR';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format((cents || 0) / 100);
  }

  function stripEuroSymbol(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\u202f/g, ' ')
      .replace(/€/g, '')
      .trim();
  }

  // Culicartel-talen (alles behalve nl): vendor in de titel i.p.v. losse vendor-regel.
  function isCulicartelLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    var shopifyLocale = (window.Shopify && window.Shopify.locale ? String(window.Shopify.locale) : '').toLowerCase();
    var activeLocale = shopifyLocale || lang;
    if (!activeLocale) return false;
    return activeLocale.indexOf('nl') !== 0;
  }

  function buildTileTitle(rawTitle, vendor) {
    var safeTitle = String(rawTitle || '');
    if (!isCulicartelLocale()) return safeTitle;

    var safeVendor = String(vendor || '').trim();
    var strippedTitle = safeTitle;
    if (safeVendor) {
      var lowerVendor = safeVendor.toLowerCase();
      var lowerTitle = safeTitle.toLowerCase();
      if (lowerTitle.indexOf(lowerVendor) === 0) {
        strippedTitle = safeTitle.slice(safeVendor.length).trim();
      } else {
        strippedTitle = safeTitle.replace(safeVendor, '').trim();
      }
    }
    if (!strippedTitle) strippedTitle = safeTitle;
    return (safeVendor ? (safeVendor + ' ' + strippedTitle) : strippedTitle).trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getCurrentPdpVariantId() {
    var select = document.querySelector('#product-select[name="id"]');
    if (select && toVariantId(select.value)) {
      return toVariantId(select.value);
    }

    var hiddenInput = document.querySelector('.productpage_wrapper input[name="id"][value]');
    if (hiddenInput && toVariantId(hiddenInput.value)) {
      return toVariantId(hiddenInput.value);
    }

    return '';
  }

  function syncPdpWishlistVariantAttrs() {
    var currentVariantId = getCurrentPdpVariantId();
    if (!currentVariantId) {
      return;
    }

    var buttons = document.querySelectorAll('.product-page-wishlist.js-wishlist-toggle');
    buttons.forEach(function (button) {
      button.setAttribute('data-variant-id', currentVariantId);
    });
  }

  function resolveToggleItem(toggle) {
    if (!toggle) {
      return null;
    }

    var variantId = toVariantId(toggle.getAttribute('data-variant-id'));
    var handle = String(toggle.getAttribute('data-product-handle') || '').trim();

    if (!variantId && toggle.classList.contains('product-page-wishlist')) {
      variantId = getCurrentPdpVariantId();
      if (variantId) {
        toggle.setAttribute('data-variant-id', variantId);
      }
    }

    if (!variantId) {
      return null;
    }

    return {
      variantId: variantId,
      handle: handle
    };
  }

  function syncButtons(root) {
    var wishlistVariantIds = getWishlistVariantIds();
    var buttons = (root || document).querySelectorAll('.js-wishlist-toggle[data-variant-id]');

    buttons.forEach(function (button) {
      var variantId = toVariantId(button.getAttribute('data-variant-id'));
      var active = variantId && wishlistVariantIds.indexOf(variantId) !== -1;

      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('is-active', !!active);

      var label = button.querySelector('.wishlist-toggle__label');
      if (label) {
        if (button.classList.contains('product-page-wishlist')) {
          label.textContent = active ? labels.onWishlist : labels.wishlist;
        } else {
          label.textContent = active ? labels.onWishlist : labels.save;
        }
      }
    });
  }

  function syncCounters() {
    var count = getWishlistItems().length;
    var counters = document.querySelectorAll('.js-wishlist-count');

    counters.forEach(function (counter) {
      counter.textContent = count;
      counter.hidden = count < 1;
    });
  }

  function emitWishlistChanged() {
    document.dispatchEvent(new CustomEvent('wishlist:changed', {
      detail: {
        count: getWishlistItems().length,
        loggedIn: !!config.isLoggedIn,
        customerId: config.customerId
      }
    }));
  }

  function closestToggle(target) {
    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    return target.closest('.js-wishlist-toggle[data-variant-id]');
  }

	  function fetchProduct(handle) {
	    return fetch(ROOT_PATH + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
	      .then(function (response) {
	        if (!response.ok) {
	          throw new Error('Product not found');
        }
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function getVariantFromProduct(product, variantId) {
    if (!product || !Array.isArray(product.variants)) {
      return null;
    }

    var idAsString = toVariantId(variantId);
    var match = null;

    product.variants.forEach(function (variant) {
      if (toVariantId(variant.id) === idAsString) {
        match = variant;
      }
    });

    return match || product.variants[0] || null;
  }

  function normalizeVariantTitle(value) {
    var title = String(value || '').trim();
    return title.toLowerCase() === 'default title' ? '' : title;
  }

  function getItemFromProduct(product, wishlistItem) {
    var variant = getVariantFromProduct(product, wishlistItem.variantId);
    if (!variant) {
      return null;
    }

    return {
      variantId: toVariantId(variant.id),
      handle: product.handle,
      vendor: product.vendor || '',
      productTitle: product.title || '',
      variantTitle: normalizeVariantTitle(variant.public_title || variant.title || ''),
      price: variant.price,
      compareAtPrice: variant.compare_at_price,
	      // Always link to the base product URL (no ?variant=).
	      url: ROOT_PATH + 'products/' + product.handle,
      imageUrl: (variant.featured_image && variant.featured_image.src) || product.featured_image || ''
    };
  }

  function fetchWishlistItem(item) {
    if (!item || !item.handle) {
      return Promise.resolve(null);
    }

    return fetchProduct(item.handle).then(function (product) {
      if (!product) {
        return null;
      }

      return getItemFromProduct(product, item);
    });
  }

  function buildWishlistCard(item) {
    var compareAtPrice = item.compareAtPrice;
    var priceHtml = '<span class="product-tile_price">' + stripEuroSymbol(formatMoney(item.price)) + '</span>';
    var variantTitleHtml = item.variantTitle ? '<p class="wishlist-tile__variant">' + escapeHtml(item.variantTitle) + '</p>' : '';
    var tileTitle = buildTileTitle(item.productTitle || '', item.vendor || '');
    var vendorHtml = isCulicartelLocale()
      ? ''
      : '<span class="product-tile_vendor">' + escapeHtml(item.vendor || '') + '</span>';

    if (compareAtPrice && compareAtPrice > item.price) {
      priceHtml = '<span class="product-tile_price-discount" style="color: #423e3e; font-family: \'Braadbaas-SemiBold\', sans-serif;">' + stripEuroSymbol(formatMoney(item.price)) + '</span>' +
        '<span class="product-tile_price-old">' + stripEuroSymbol(formatMoney(compareAtPrice)) + '</span>';
    }

    return '' +
      '<article class="wishlist-tile-card">' +
      '<div class="tile-wrapper productpage-tile wishlist-tile">' +
      '<a class="product-tile_imagewrapper wishlist-tile__image-link" href="' + escapeHtml(item.url) + '">' +
      '<img class="product-tile_image" src="' + escapeHtml(item.imageUrl) + '" alt="' + escapeHtml(item.productTitle) + '" loading="lazy" />' +
      '</a>' +
      '<div class="product-tile_info">' +
      vendorHtml +
      '<a class="wishlist-tile__title-link" href="' + escapeHtml(item.url) + '"><h6 class="product-tile_title">' + escapeHtml(tileTitle) + '</h6></a>' +
      variantTitleHtml +
      '<div class="product-tile_price-container">' + priceHtml + '</div>' +
      '<div class="wishlist-tile__actions">' +
      '<button type="button" class="wishlist-tile__cart js-wishlist-add-to-cart" data-variant-id="' + escapeHtml(item.variantId) + '">' + CART_ICON_SVG + '<span>' + escapeHtml(labels.cart) + '</span></button>' +
      '<button type="button" class="wishlist-tile__remove js-wishlist-toggle" data-product-handle="' + escapeHtml(item.handle) + '" data-variant-id="' + escapeHtml(item.variantId) + '" aria-label="' + escapeHtml(labels.removeFromWishlist) + '">' +
      BIN_ICON_SVG +
      '</button>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</article>';
  }

  function addVariantToCart(variantId) {
    var id = toVariantId(variantId);
    if (!id) {
      return Promise.resolve(false);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(id),
        quantity: 1
      })
    })
      .then(function (response) {
        return response.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function setAddToCartButtonState(button, state) {
    var labelNode = button ? button.querySelector('span:last-child') : null;
    if (!button || !labelNode) {
      return;
    }

    button.classList.remove('is-loading');
    button.classList.remove('is-in-cart');
    button.disabled = false;

    if (state === 'loading') {
      button.classList.add('is-loading');
      button.disabled = true;
      labelNode.textContent = labels.adding;
      return;
    }

    if (state === 'success') {
      labelNode.textContent = labels.added;
      return;
    }

    if (state === 'retry') {
      labelNode.textContent = labels.retry;
      return;
    }

    if (state === 'in-cart') {
      button.classList.add('is-in-cart');
      button.disabled = true;
      labelNode.textContent = labels.addedToCart;
      return;
    }

    labelNode.textContent = labels.cart;
  }

  function fetchCartVariantIds(options) {
    var forceRefresh = !!(options && options.forceRefresh);

    if (!forceRefresh && Object.keys(cartVariantIdsCache).length) {
      return Promise.resolve(cartVariantIdsCache);
    }

    if (cartFetchPromise && !forceRefresh) {
      return cartFetchPromise;
    }

    cartFetchPromise = fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart unavailable');
        }
        return response.json();
      })
      .then(function (cart) {
        var nextMap = {};
        var items = (cart && cart.items) || [];

        items.forEach(function (item) {
          var key = toVariantId(item.variant_id || item.id);
          if (key) {
            nextMap[key] = true;
          }
        });

        cartVariantIdsCache = nextMap;
        return cartVariantIdsCache;
      })
      .catch(function () {
        return cartVariantIdsCache;
      })
      .finally(function () {
        cartFetchPromise = null;
      });

    return cartFetchPromise;
  }

  function syncAddToCartButtons(root) {
    var buttons = (root || document).querySelectorAll('.js-wishlist-add-to-cart[data-variant-id]');
    if (!buttons.length) {
      return;
    }

    fetchCartVariantIds().then(function (cartMap) {
      buttons.forEach(function (button) {
        var variantId = toVariantId(button.getAttribute('data-variant-id'));
        if (variantId && cartMap[variantId]) {
          setAddToCartButtonState(button, 'in-cart');
        } else {
          setAddToCartButtonState(button, 'idle');
        }
      });
    });
  }

  function renderWishlistLoadingState(grid, count) {
    var safeCount = count > 0 ? count : 1;
    var skeletons = '';
    var i = 0;

    for (i = 0; i < safeCount; i += 1) {
      skeletons += '' +
        '<article class="wishlist-skeleton" aria-hidden="true">' +
        '<div class="wishlist-skeleton__image"></div>' +
        '<div class="wishlist-skeleton__content">' +
        '<div class="wishlist-skeleton__line wishlist-skeleton__line--short"></div>' +
        '<div class="wishlist-skeleton__line"></div>' +
        '<div class="wishlist-skeleton__line wishlist-skeleton__line--tiny"></div>' +
        '<div class="wishlist-skeleton__actions">' +
        '<div class="wishlist-skeleton__button"></div>' +
        '<div class="wishlist-skeleton__button wishlist-skeleton__button--square"></div>' +
        '</div>' +
        '</div>' +
        '</article>';
    }

    grid.classList.add('is-loading');
    grid.innerHTML = skeletons;
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) {
      return;
    }

    var emptyState = document.querySelector('[data-wishlist-empty]');
    var items = getWishlistItems();

    if (!items.length) {
      grid.innerHTML = '';
      if (emptyState) {
        emptyState.hidden = false;
      }
      return;
    }

    if (emptyState) {
      emptyState.hidden = true;
    }

    renderWishlistLoadingState(grid, Math.min(items.length, 4));

    Promise.all(items.map(fetchWishlistItem)).then(function (resolvedItems) {
      var validItems = resolvedItems.filter(function (entry) {
        return entry && entry.variantId;
      });

      if (!validItems.length) {
        saveWishlistItems([], { skipRemoteSync: false });
        grid.innerHTML = '';
        if (emptyState) {
          emptyState.hidden = false;
        }
        syncCounters();
        grid.classList.remove('is-loading');
        return;
      }

      var markup = validItems.map(buildWishlistCard).join('');
      grid.classList.remove('is-loading');
      grid.innerHTML = markup;
      syncButtons(grid);
      syncAddToCartButtons(grid);
    });
  }

  function mergeIntoCurrentWishlist(extraItems, options) {
    var merged = uniqItems(getWishlistItems().concat(parseList(extraItems)));
    saveWishlistItems(merged, options || {});
    return merged;
  }

  function migrateGuestWishlistToCustomer() {
    if (!config.isLoggedIn || !config.customerId) {
      return;
    }

    var guestList = readItemsFromKey(GUEST_STORAGE_KEY);
    var storedCustomerList = readItemsFromKey(getCustomerStorageKey());
    var metafieldList = uniqItems(parseList(config.customerWishlistMetafield));
    var merged = uniqItems(storedCustomerList.concat(metafieldList).concat(guestList));

    storageSet(getCustomerStorageKey(), JSON.stringify(serializeItems(merged)));

    if (guestList.length) {
      storageRemove(GUEST_STORAGE_KEY);
    }

    if (!areWishlistListsEqual(merged, metafieldList)) {
      queueRemoteSync(merged);
    }
  }

  function parseRemoteWishlist(payload) {
    if (Array.isArray(payload)) {
      return payload;
    }

    if (payload && Array.isArray(payload.items)) {
      return payload.items;
    }

    if (payload && Array.isArray(payload.variant_ids)) {
      return payload.variant_ids;
    }

    if (payload && Array.isArray(payload.handles)) {
      return payload.handles;
    }

    if (payload && payload.data && Array.isArray(payload.data.items)) {
      return payload.data.items;
    }

    if (payload && Array.isArray(payload.wishlist)) {
      return payload.wishlist;
    }

    if (payload && Array.isArray(payload.wishlist_items)) {
      return payload.wishlist_items;
    }

    return [];
  }

  function fetchRemoteWishlist() {
    if (!config.isLoggedIn || !config.customerId || !config.syncEnabled || !config.syncUrl) {
      return Promise.resolve([]);
    }

    var separator = config.syncUrl.indexOf('?') === -1 ? '?' : '&';
    var url = config.syncUrl + separator + 'customer_id=' + encodeURIComponent(String(config.customerId));

    return fetch(url, {
      method: 'GET',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Remote wishlist unavailable');
        }
        return response.json();
      })
      .then(parseRemoteWishlist)
      .catch(function () {
        return [];
      });
  }

  function pushRemoteWishlist(items) {
    if (!config.isLoggedIn || !config.customerId || !config.syncEnabled || !config.syncUrl) {
      return Promise.resolve();
    }

    if (isSyncInFlight) {
      return Promise.resolve();
    }

    isSyncInFlight = true;
    var normalizedItems = uniqItems(items);
    var handles = normalizedItems
      .map(function (item) {
        return String(item.handle || '').trim();
      })
      .filter(function (value) {
        return !!value;
      });

    return fetch(config.syncUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        customer_id: String(config.customerId),
        items: normalizedItems,
        variant_ids: normalizedItems.map(function (item) {
          return item.variantId;
        }),
        handles: handles,
        wishlist_handles: handles
      })
    })
      .then(function (response) {
        return response;
      })
      .catch(function () {
        return null;
      })
      .then(function (result) {
        isSyncInFlight = false;
        return result;
      });
  }

  function queueRemoteSync(items) {
    if (!config.isLoggedIn || !config.customerId || !config.syncEnabled || !config.syncUrl) {
      return;
    }

    if (syncTimer) {
      window.clearTimeout(syncTimer);
    }

    syncTimer = window.setTimeout(function () {
      syncTimer = null;
      pushRemoteWishlist(items);
    }, SYNC_DEBOUNCE_MS);
  }

  document.addEventListener('click', function (event) {
    var addToCartButton = event.target && event.target.closest ? event.target.closest('.js-wishlist-add-to-cart[data-variant-id]') : null;
    if (addToCartButton) {
      if (addToCartButton.disabled || addToCartButton.classList.contains('is-in-cart')) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      var cartVariantId = addToCartButton.getAttribute('data-variant-id');
      setAddToCartButtonState(addToCartButton, 'loading');

      addVariantToCart(cartVariantId).then(function (wasAdded) {
        if (!wasAdded) {
          setAddToCartButtonState(addToCartButton, 'retry');
          window.setTimeout(function () {
            setAddToCartButtonState(addToCartButton, 'idle');
          }, 1200);
          return;
        }

        var addedVariantId = toVariantId(cartVariantId);
        if (addedVariantId) {
          cartVariantIdsCache[addedVariantId] = true;
        }
        setAddToCartButtonState(addToCartButton, 'success');
        window.setTimeout(function () {
          setAddToCartButtonState(addToCartButton, 'in-cart');
        }, 1200);
      });
      return;
    }

    var toggle = closestToggle(event.target);
    if (!toggle) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var toggleItem = resolveToggleItem(toggle);
    if (!toggleItem) {
      return;
    }

    if (toggle.classList.contains('wishlist-tile__remove')) {
      toggle.disabled = true;
      toggle.classList.add('is-loading');
    }

    upsertWishlistItem(toggleItem);
    syncButtons(document);
    syncCounters();
    renderWishlistPage();
    emitWishlistChanged();
  });

  document.addEventListener('keydown', function (event) {
    var toggle = closestToggle(event.target);
    if (!toggle) {
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggle.click();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('#product-select[name="id"]')) {
      syncPdpWishlistVariantAttrs();
      syncButtons(document);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    migrateGuestWishlistToCustomer();
    syncPdpWishlistVariantAttrs();

    syncButtons(document);
    syncCounters();
    renderWishlistPage();

    fetchRemoteWishlist().then(function (remoteItems) {
      var currentItems = getWishlistItems();
      var mergedItems = uniqItems(currentItems.concat(parseList(remoteItems)));

      if (!areWishlistListsEqual(currentItems, mergedItems)) {
        saveWishlistItems(mergedItems, { skipRemoteSync: true });
      }

      if (!areWishlistListsEqual(remoteItems, mergedItems)) {
        pushRemoteWishlist(mergedItems);
      }

      syncPdpWishlistVariantAttrs();
      syncButtons(document);
      syncCounters();
      renderWishlistPage();
      emitWishlistChanged();
    });
  });

  window.BBWishlist = {
    getWishlist: getWishlistItems,
    getWishlistVariantIds: getWishlistVariantIds,
    hasVariant: hasVariant,
    toggleVariant: upsertWishlistItem,
    renderPage: renderWishlistPage,
    pushRemoteWishlist: function () {
      return pushRemoteWishlist(getWishlistItems());
    }
  };
})();
